const API_BASE_URL: string = "/api";

// Site Type

const PRIVATE_SITE: number = 0;
const PUBLIC_SITE: number = 1;
const ACCOUNT_TYPE_NORMAL: number = 1;
const ACCOUNT_TYPE_TEMPORARY: number = 2;
const PRODUCT_TYPE_MOVIE_REWARDS: number = 1;
const PRODUCT_TYPE_VOUCHER_MANAGER: number = 2;
const TYPE_MOVIE_DETAILS: number = 1;
const SITE_LIGHT_THEME: number = 1;
const SITE_DARK_THEME: number = 2;

// Ticket Types
const TYPE_TICKET_ADULT: number = 1;
const TYPE_VOUCHER_ADULT: number = 2;
const TYPE_TICKET_MANUAL: number = 3;
const TYPE_UNUSED: number = 4;
const TYPE_VOUCHER_KIDS: number = 5;
const TYPE_VOUCHER_MANAGER: number = 6;
const TYPE_SEASONAL_VOUCHER: number = 7;
const TYPE_GIFTING_VOUCHER: number = 9;

// Advert category types
const ADVERT_CATEGORY_SEASONAL_VOUCHER: number = 2;

// Experience types
const CLASS_STANDARD: number = 1;
const CLASS_GOLD: number = 2;
const CLASS_PREMIUM: number = 4;
const CLASS_PREMIUM_PLUS: number = 5;
const CLASS_IMAX: number = 6;

// Banner Carousel Image Sources
const SOURCE_LOCAL_IMAGE: number = 0;
const SOURCE_BO_IMAGE: number = 1;
const SOURCE_BO_TRAILER: number = 2;
const SOURCE_LOCAL_TRAILER: number = 3;

// Cinema Groups
const VILLAGE_CINEMAS: number = 50;
const EVENT_CINEMAS: number = 51;
const HOYTS_CINEMAS: number = 52;
const LUNA_CINEMAS: number = 70;
const READING_CINEMAS: number = 72;
const ORANA_CINEMAS: number = 69;
const PALACE_CINEMAS: number = 53;
const MOVING_STORY: number = 76;
const ANGELIKA_CINEMAS: number = 96;
const UNITED_CINEMAS: number = 102;

// Authentication Types
const AUTH_APPLICATION_SECURITY: number = 1;
const AUTH_JWT: number = 2;
const AUTH_PARTNER_INTEGRATION: number = 3;
const AUTH_OTP: number = 4;
const AUTH_JWT_EMAIL: number = 1;
const AUTH_JWT_MEMBER_ID: number = 0;
const AUTH_PARTNER_INTEGRATION_EMAIL: number = 1;
const AUTH_PARTNER_INTEGRATION_MEMBER_ID: number = 0;

// Promo Code Categories
const CATEGORY_STANDARD: number = 0;
const CATEGORY_ADVANCED: number = 1;
const CATEGORY_SUBSCRIBER: number = 2;

// VM/Gifting Price Display Types
const SITE_DISPLAY_STANDARD: number = 1;
const SITE_DISPLAY_RRP: number = 2;
const SITE_DISPLAY_COMPLIMENTARY: number = 3;

export {
    API_BASE_URL,
    PRIVATE_SITE,
    PUBLIC_SITE,
    ACCOUNT_TYPE_NORMAL,
    ACCOUNT_TYPE_TEMPORARY,
    TYPE_TICKET_ADULT,
    TYPE_VOUCHER_ADULT,
    TYPE_TICKET_MANUAL,
    TYPE_UNUSED,
    TYPE_VOUCHER_KIDS,
    CLASS_STANDARD,
    CLASS_GOLD,
    CLASS_PREMIUM,
    CLASS_PREMIUM_PLUS,
    CLASS_IMAX,
    PRODUCT_TYPE_MOVIE_REWARDS,
    PRODUCT_TYPE_VOUCHER_MANAGER,
    TYPE_VOUCHER_MANAGER,
    TYPE_SEASONAL_VOUCHER,
    TYPE_GIFTING_VOUCHER,
    VILLAGE_CINEMAS,
    EVENT_CINEMAS,
    HOYTS_CINEMAS,
    LUNA_CINEMAS,
    READING_CINEMAS,
    PALACE_CINEMAS,
    ORANA_CINEMAS,
    MOVING_STORY,
    ANGELIKA_CINEMAS,
    UNITED_CINEMAS,
    AUTH_APPLICATION_SECURITY,
    AUTH_JWT,
    AUTH_PARTNER_INTEGRATION,
    AUTH_OTP,
    AUTH_JWT_EMAIL,
    AUTH_JWT_MEMBER_ID,
    AUTH_PARTNER_INTEGRATION_EMAIL,
    AUTH_PARTNER_INTEGRATION_MEMBER_ID,
    SITE_LIGHT_THEME,
    SITE_DARK_THEME,
    TYPE_MOVIE_DETAILS,
    SOURCE_LOCAL_IMAGE,
    SOURCE_BO_IMAGE,
    SOURCE_BO_TRAILER,
    SOURCE_LOCAL_TRAILER,
    ADVERT_CATEGORY_SEASONAL_VOUCHER,
    CATEGORY_ADVANCED,
    CATEGORY_SUBSCRIBER,
    CATEGORY_STANDARD,
    SITE_DISPLAY_STANDARD,
    SITE_DISPLAY_RRP,
    SITE_DISPLAY_COMPLIMENTARY,
};
